export default __webpack_public_path__ + "static/media/q19_step1.128b23be.png";